import React from 'react'
import classNames from 'classnames'
import { Icon } from '@/ui/atoms/Icon'
import { CMSButtonPropsType } from '@/ui/components/CMSButton'
import Link from 'next/link'

type LabelClickableProps = {
  title: string
  href: string
  icon?: string
  inverted?: boolean
  className?: string
}

export const LabelClickable: React.FC<LabelClickableProps> = ({
  title,
  href,
  icon,
  inverted,
  className: classNameFromProps,
}) => {
  return (
    <Link
      href={href}
      className={classNames(
        classNameFromProps,
        {
          'bg-bg-base-transparent-10 hover:bg-bg-base-transparent-20': inverted,
          'bg-bg-intense-transparent-10 hover:bg-bg-intense-transparent-30': !inverted,
        },
        'px-2 py-2 rounded bg-white/10 backdrop-blur-sm inline-flex items-center gap-1 transition-colors',
      )}
    >
      {icon && typeof icon === 'string' && <Icon name={icon} className="text-white" />}
      <span className="text-label-XS-regular text-white">{title}</span>
    </Link>
  )
}
